import { gql } from "@apollo/client"
import { Company, SortByEnum } from "@oysterhr/schema"
import { useQuery } from "@oysterhr/core"
import { compact } from "lodash-es"

export const COMPANY_PAYROLL_ENTITIES = gql`
  query CompanyPayrollEntities(
    $companyId: ID!
    $query: String
    $page: Int
    $perPage: Int
    $sort: SortByEnum
  ) {
    company(companyId: $companyId) {
      id
      name
      isCustomer
      authorizations {
        actions
      }
      payrollEntities(query: $query, page: $page, perPage: $perPage, sort: $sort) {
        collection {
          id
          name
          createdAt
          payrollCycleType
          cutOffMonthDay
          employerOfRecordCountry {
            id
            alpha2
          }
        }
        metadata {
          totalPages
          totalCount
          currentPage
          limitValue
        }
      }
    }
  }
`

type PayrollEntitiesType = {
  companyId: string
  query?: string
  page?: number
  perPage?: number
  sort?: SortByEnum
}

export const usePayrollEntities = ({
  companyId,
  query,
  sort,
  page = 1,
  perPage = 100,
}: PayrollEntitiesType) => {
  const { data, ...rest } = useQuery<{ company: Company }>(COMPANY_PAYROLL_ENTITIES, {
    variables: { companyId, query, page, perPage, sort: sort },
    skip: !companyId,
  })

  return {
    data: {
      company: {
        ...data?.company,
        payrollEntities: {
          collection: compact([...(data?.company?.payrollEntities?.collection || [])]),
          metadata: data?.company.payrollEntities.metadata,
        },
      } as Pick<Company, "name" | "payrollEntities" | "isCustomer" | "authorizations" | "modeName">,
    },
    ...rest,
  }
}
